<template>
  <main>
    <div>
      <div class="container">
        <h5 class="text-danger" v-if="!joinUrl">
          Something went wrong, class details not available. Please go back to the courses dashboard and try joining the class again.
        </h5>
        <div v-else>
          <div>
            <h5>
              Your class will be joined on the Webex application on your device. If you do not have Webex already installed on your device, then install it first and then click on join button, also you can join the meeting on the browser too.
            </h5>
            <a class="btn btn-primary" @click="joinInWebexApp" :href="joinUrl" target="_blank" v-if="status == 'NOT_STARTED'">Join Class</a>
            <button class="btn btn-primary" v-else-if="status == 'JOINING'" disabled>Joining</button>
            <p v-else-if="status == 'JOINED'">Your class has been joined. If you are having any trouble, please refresh the page.</p>
            <p class="text-danger" v-else-if="status == 'ERROR' && errorMsg">{{ errorMsg }}</p>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: "Webex",
  props: {
    contentData: Object,
    productVariantData: Object
  },
  data() {
    return {
      status: 'NOT_STARTED',
      errorMsg: undefined,
    };
  },
  
  methods: {
    ...mapActions("content", ["markLiveClassAttendance", "markLiveClassSingleAttendance"]),

    async markAttendance() {
      if (this.currentUser) {
        const attendanceObj = {
          contentID: this.contentData.id,
          userID: this.currentUser?.id,
          status: "Present",
          attendedFrom: "Online",
          timeIn: new Date().toISOString(),
          isMarkLate: false,
          isLeftEarly: false,
        };

        await this.markLiveClassSingleAttendance(attendanceObj);
        console.log('attendance marked');
      }
    },

    joinInWebexApp() {

      this.markAttendance()
        .then(() => console.log('attendance marked'))
        .catch((err) => console.error('error while marking attendance', err))
            this.status = 'JOINED';
    },
  },

  computed: {

    joinUrl() {
      if (!this.contentData || !this.contentData.data) {
           return;
      }
      const url = this.contentData?.data?.joining_Url;

      if(url && url != '')
        return url;
    },

    accessToken() {
      return this.contentData?.data?.token;
    },

    meetingDestination() {
      if (!this.contentData || !this.contentData.data) {
           return;
      }
      const url = this.contentData.extraProperties.WebLink;

      if(url && url != '')
        return url;
    },

    openMeetingInWidget() {
      return this.contentData?.data?.openInSDK ?? false;
    }
  },
};
</script>

<style>
  .wxc-title{
    display: none;
  }
</style>

<style scoped>
.container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 80vh;
}

main {
  width: 80%;
  margin: auto;
  text-align: center;
}

main button {
  margin-top: 20px;
  background-color: #2d8cff;
  color: #ffffff;
  text-decoration: none;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 40px;
  padding-right: 40px;
  display: inline-block;
  border-radius: 10px;
  cursor: pointer;
  border: none;
  outline: none;
}

main button:hover {
  background-color: #2681f2;
}
</style>

<style>
#webex-meeting-widget {
  background-color: #000;
}
</style>